<h1 mat-dialog-title>Choose a status</h1>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (error) {
  <p class="mm-error">{{ error }}</p>
  }
  <mat-selection-list #selectionList [multiple]="false">
    @for (status of statuses(); track status) {
    <mat-list-option
      cdkFocusInitial
      class="mat-list-item--with-icon"
      [ngClass]="{ 'mat-list-item--selected': getValue(selectionList) === status }"
      [value]="status"
    >
      <span>{{ dataOrderService.getOrderStatusLabel(status) }}</span>
      @if (getValue(selectionList) === status) {
      <mat-icon class="mm-text-accent">check_circle</mat-icon>
      }
    </mat-list-option>
    }
  </mat-selection-list>
  @if (statuses().length === 0) {
  <div class="no-statuses">
    It seems like there are no statuses available for bulk updating. Please choose a different
    <b>from</b> status.
  </div>
  }
</div>
<mat-dialog-actions class="dialog-actions" align="end">
  @if (selectionList.selectedOptions.hasValue()) {
  <p class="mm-mt-2 mm-text-left">
    You have selected <b>{{ orderCount }}</b> order{{ orderCount > 1 ? 's' : '' }} to change
    from <b>{{ dataOrderService.getOrderStatusLabel(fromStatus) }}</b> to
    <b>{{ dataOrderService.getOrderStatusLabel(getValue(selectionList)) }}</b
    >.
  </p>
  }
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="submit()" class="mm-bg-accent mm-text-white mm-ml-2">
    Change Status
  </button>
</mat-dialog-actions>
